
export function getGetCare({
    disableMyChartMenuItems,
    enableInHomeFeature,
    notPharmacyProxy,
    isMyChartUser,
    isPrimaryUser
}) {

    return {
        show: notPharmacyProxy,
        navHead: {
            label: 'Schedule & Search',
            url: null,
            altUrls: ['/getcare', '/schedule','/schedulesearch'],
            icon: 'medical'
        },
        navItems: [
            {
                label: 'Schedule Now',
                show: isMyChartUser,
                disabled: disableMyChartMenuItems,
                url: '/schedulenow',
                altUrls: [
                    '/schedulingfor',
                    '/evisitnow',
                    '/evisittravel',
                    '/evisit',
                    '/aatravel',
                    '/videovisitoptions',
                    '/videovisitscheduledfor',
                    '/schedulevideovisit',
                    '/videovisitscheduledfor',
                    '/videoondemand',
                    '/schedulevisit',
                    '/scheduling',
                    '/vaccineeligibility'
                ],
                subMenuItems: null,
            },
            {
                label: 'Find Care',
                show: notPharmacyProxy,
                url: '/findcare',
                altUrls: ['/inperson'],
                subMenuItems: null
            },
            {
                label: 'Favorite Doctors',
                show: isPrimaryUser,
                url: '/favorites',
                subMenuItems: null
            },
            {
                label: 'In-Home Services',
                show: enableInHomeFeature,
                url: '/inhomevaccine',
                altUrls: ['/inhomeschedule', '/inhomeschedules'],
                subMenuItems: null
            }
        ]
    }
}